<div class="container-fluid">
    <div class="row">
        <div class="modal-header border-0 offset-md-10 col-md-2">
            <button mat-button mat-dialog-close type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</div>
<div class="container-fluid pb-5 h-100">
    <div class="row">
        <div class="col-12 mt-2">
            <app-expandible-title title="Enquadramento - Memória cálculo" paragraphClass="h5" [expandible]="false"
                                  [exportable]="true" [exportCsv]="false" (onPDFExport)="exportPDF($event)"
                                  (onXLSXExport)="exportXLSX($event)"></app-expandible-title>
        </div>
    </div>
    <div class="row">
        <div class="col-12 mt-2">
            <app-expandible-title title="Carteira" paragraphClass="h5" [expandible]="false"></app-expandible-title>
        </div>
    </div>
    <div class="ml-4 label-maps">
        <div class="row mb-3">
            <div class="flex-column w-25 flex-shrink-1">
                Nome: <span class="font-weight-bold">{{memoriaCalculo?.carteira.nome}}</span>
            </div>
            <div class="flex-column w-45">
                Nome completo: <span class="font-weight-bold">{{memoriaCalculo?.carteira.nomeCompleto}}</span>
            </div>
            <div class="flex-column w-20 flex-shrink-1">
                CNPJ: <span class="font-weight-bold">{{formatCnpj(memoriaCalculo?.carteira.cnpj)}}</span>
            </div>
        </div>
        <div class="row mb-3">
            <div class="flex-column w-25 flex-shrink-1">
                Administrador: <span class="font-weight-bold">{{memoriaCalculo?.carteira.admin}}</span>
            </div>
            <div class="flex-column w-25">
                Gestor: <span class="font-weight-bold">{{memoriaCalculo?.carteira.gestor}}</span>
            </div>
        </div>
        <div class="row mb-3">
            <div class="flex-column w-25 flex-shrink-1">
                Administrador - Grupo Econômico: <span class="font-weight-bold">{{memoriaCalculo?.carteira.grupoEconomicoAdmin}}</span>
            </div>
            <div class="flex-column w-25">
                Gestor - Grupo Econômico: <span class="font-weight-bold">{{memoriaCalculo?.carteira.grupoEconomicoGestor}}</span>
            </div>
        </div>
        <div class="row mb-3">
            <div class="flex-column w-25 flex-shrink-1">
                Data constituição: <span class="font-weight-bold">{{memoriaCalculo?.carteira.dataConstituicao | date: 'dd/MM/yyyy'}}</span>
            </div>
        </div>
        <div class="row mb-3">
            <div class="flex-column w-25 flex-shrink-1">
                Data posição: <span class="font-weight-bold">{{resultado.dataEnquadramento | date: 'dd/MM/yyyy'}}</span>
            </div>
            <div class="flex-column w-45">
                Data hora execução: <span class="font-weight-bold">{{resultado.timeStamp | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 mt-2">
            <app-expandible-title title="Regra" paragraphClass="h5" [expandible]="false"></app-expandible-title>
        </div>
    </div>
    <div class="ml-4 label-maps">
        <div class="row mb-3">
            <div class="flex-column w-65">
                Nome: <span class="font-weight-bold">{{memoriaCalculo?.regra.nome}}</span>
            </div>
            <div class="flex-column flex-shrink-1 pl-5">
                Função: <span class="font-weight-bold">{{memoriaCalculo?.regra.funcao}}</span>
            </div>
        </div>
        <div class="row mb-3">
            <div class="flex-column w-75">
                Descrição: <span class="font-weight-bold" *ngIf="funcao" [innerHTML]="funcao.descricao"></span>
            </div>
        </div>
        <div class="row mb-3">
            <div class="flex-column flex-shrink-1">
                Data início vigência: <span class="font-weight-bold">{{memoriaCalculo?.regra.inicioVigencia | date: 'dd/MM/yyyy'}}</span>
            </div>
            <div class="flex-column flex-shrink-1 pl-5">
                Data fim vigência: <span class="font-weight-bold">{{memoriaCalculo?.regra.fimVigencia | date: 'dd/MM/yyyy'}}</span>
            </div>
            <div class="flex-column flex-shrink-1 pl-5">
                Utilizar carteira explodida: <span class="font-weight-bold">{{ memoriaCalculo?.regra.utilizaCarteiraExplodida ? 'Sim' : 'Não' }}</span>
            </div>
        </div>
        <div class="row" *ngIf="funcao && memoriaCalculo">
            <parametro-funcao-detalhe [valores]="memoriaCalculo?.regra.parametros" [parametros]="funcao.parametros"></parametro-funcao-detalhe>
        </div>
    </div>
    <div class="row">
        <div class="col-12 mt-2">
            <app-expandible-title title="Resultado" paragraphClass="h5" [expandible]="false"></app-expandible-title>
        </div>
    </div>
    <div class="ml-4">
        <div class="card bg-2 resultado-container">
            <div class="card-body">
                <app-expandible-title [title]="'Regra'" [paragraphClass]="'h5'" [expandible]="false"></app-expandible-title>
                <div class="label-maps">
                    <div class="row mb-3">
                        <div class="col align-self-center">
                            Nome: <span class="font-weight-bold">{{memoriaCalculo?.regra.nome}}</span>
                        </div>
                        <div class="col">
                            <div class="row justify-content-end w-100">
                                <div class="flex-column pr-2 align-self-center"> Status:</div>
                                <div class=" rounded flex-column p-2 flex-wrap justify-content-center " [class.enquadrada]="isStatusEnquadrada()"
                                     [class.desenquadrada]="!isStatusEnquadrada()"><span class="font-weight-bold">{{resultado.status}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3 mensagem-resultado">
                        <div class="col">
                            Mensagem: <span class="font-weight-bold">{{resultado.mensagem}}</span>
                        </div>
                    </div>
                </div>
                <hr/>
                <app-expandible-title [title]="''" [paragraphClass]="'h5'" [bodyTemplate]="composicao"></app-expandible-title>
                <ng-template #composicao>
                    <div class="mb-4 flex-wrap label-maps" *ngFor="let memoria of memoriaCalculo?.detalhes">
                        <div *ngIf="memoria.observacao">
                            {{memoria.observacao}}
                        </div>
                        <div *ngIf="memoria.width100">
                            <app-total-table [totalRegistros]="calculaLinhasTotais(memoria)" [showRegistersPerPage]="false"></app-total-table>
                        </div>
                        <table
                            class="table label-maps table-striped table-bordered table-hover table-responsive-sm table-responsive-md table-responsive-xl"
                            [class.w-50]="!memoria.width100">
                            <thead>
                            <tr>
                                <th *ngFor="let header of memoria.header">{{header}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let row of memoria.conteudoPaginado.content">
                                <td *ngFor=" let col of row.colunas"
                                    [class.campoValor]="col.campoNumerico" [class.campoTotal]="row.total"
                                    [class.text-danger]="!isEnquadrada(row)">{{col.valor}}</td>
                            </tr>
                            <tr *ngIf="memoria.conteudoPaginado.content.length === 0">
                                <td [colSpan]="memoria.header.length" class="text-right">
                                    Nenhum registro encontrado com o(s) parâmetro(s) informado(s).
                                </td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr *ngIf="memoria.conteudoPaginado.metadata.number == memoria.conteudoPaginado.metadata.totalPages"
                                class="font-weight-bold">
                                <td *ngFor="let footer of memoria.footer"
                                    [class.campoValor]="footer !== memoria.footer[0]">{{footer}}</td>
                            </tr>
                            </tfoot>
                        </table>
                        <div class="d-flex justify-content-center mb-5" *ngIf="memoria.width100">
                            <pagination [totalItems]="memoria.conteudoPaginado.metadata.totalElements" [maxSize]="40" [itemsPerPage]="20"
                                        [(ngModel)]="memoria.conteudoPaginado.metadata.number" (pageChanged)="changePage($event,memoria)"
                                        previousText="Anterior" nextText="Próximo"></pagination>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
